import { useEffect } from "react";
import { toast } from "sonner";
import { useAcademicYear } from "../../../../core/common/context/AcademicYearContext";
import { getEDTByTeacherPDF } from "../../../../api/edt";
import { useSelector } from "react-redux";

//Typage des props parents
type Props = {
  show: boolean;
  metaData: any;
  onClose: () => void;
};
const EDTApercuByTeacher = ({ show, metaData, onClose }: Props) => {
  const { selectedYear } = useAcademicYear();

  // récupérer les infos du prof
  const teacher = useSelector((state: any) => state.auth.user);

  const run = async () => {
    const payload = {
      id_teacherProfil: teacher?.id,
      id_versionEDT: metaData?.id_versionEDT,
    };
    toast.promise(
      (async () => {
        const response = await getEDTByTeacherPDF(selectedYear?.id, payload);

        const url = URL.createObjectURL(
          new Blob([response], { type: "application/pdf" }),
        );

        return url; // ⬅️ on retourne l’URL au toast
      })(),
      {
        loading: "Génération de l'aperçu...",
        success: (url) => ({
          message: "Le fichier est prêt",
          action: {
            label: "Ouvrir",
            onClick: () => {
              window.open(url, "_blank", "noopener,noreferrer");
            },
          },
        }),
        error: (error) => {
          // console.log("Error", error);
          return (
            error.response?.data?.message ||
            error.response?.data?.error ||
            "Une erreur s'est produite, réessayez plus tard"
          );
        },
      },
    );

    onClose();
  };

  useEffect(() => {
    if (!show) return;
    run();
  }, [show, teacher, metaData, selectedYear, onClose]);

  return null;
};

export default EDTApercuByTeacher;
